import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import auth0CallbackGuestState from './Auth0CallbackGuest.state';
import { handleAuth0GuestCallback } from '@redux/actions/auth0-callback/auth0CallbackActions';

// Components
import LoadingScreen from '@components/loading-screen';

const Auth0CallbackGuest = () => {
  const dispatch: AppDispatch = useDispatch();
  const email = useSelector(auth0CallbackGuestState);

  useEffect(() => {
    dispatch(handleAuth0GuestCallback(email));
  }, []);

  return <LoadingScreen show />;
};

export default Auth0CallbackGuest;
